import StarIcon from "../../../images/icons/starIcon";
import ImageComponent from "../shared/ImageComponent";
import profileImage from "../../../images/profileImage.png";
import NoImage from "../../../images/profileImage.png";
import ZipCodeIcon from "../../../images/icons/zipCode";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import {interventionDate} from "../../../utils/date";
import {useSelector} from "react-redux";
import {userRoleList} from "../../../utils/constants";

const InterventionItem = ({className, intervention}) => {
  const {selectedRole} = useSelector((state) => state.auth.auth);
  const {Offer_Proposal, startDate, title} = intervention;
  const client = Offer_Proposal?.Offer
    ? Offer_Proposal?.Offer?.Client?.User
    : Offer_Proposal?.directChat?.chatroom?.Client?.User;
  const technician = Offer_Proposal?.Technician?.User;
  const contact =
    selectedRole === userRoleList.CLIENT ? technician : client;
  const postCode = Offer_Proposal?.Offer
    ? Offer_Proposal?.Offer?.postCode
    : Offer_Proposal?.zipCode;
  const ville = Offer_Proposal?.Offer
    ? Offer_Proposal?.Offer?.ville
    : Offer_Proposal?.city;
  const address = Offer_Proposal?.Offer
    ? Offer_Proposal?.Offer?.address
    : Offer_Proposal?.address;
  return (
    <div
      className={
        "w-full flex flex-col justify-start !py-3 !pl-3 !pr-2   " + className
      }
    >
      <div className="flex items-center justify-start gap-1 flex-nowrap w-full ">
        <div className="relative min-w-8 flex-shrink-0">
          {!!contact?.avgRating && (
            <div className="bg-[#FFC107] w-[30px] flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[7px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] ">
              {Number(contact?.avgRating).toFixed(2) ?? "--"}
              <StarIcon className="fill-white stroke-none w-2 h-2" />
            </div>
          )}
          <ImageComponent
            src={buildImageUrl(contact?.imageUri)}
            alt={`${contact?.firstName ?? ""} ${contact?.lastName ?? ""}`.trim()}
            className=" w-8 h-8 rounded-full object-cover"
            fallback={
              <img
                src={NoImage}
                alt=""
                className=" w-8 h-8 rounded-full object-cover"
                width="130"
              />
            }
          />
        </div>
        <div className="flex flex-col justify-center items-start w-[calc(100%-32px)] ">
          <div className="text-[#19295C] w-full   font-bold text-sm capitalize flex items-center flex-nowrap justify-between  ">
            <span className="truncate max-w-[clac(100%-100px)] capitalize">
              {[contact?.lastName, contact?.firstName]
                .filter(Boolean)
                .join(" ") || "--"}{" "}
            </span>
            <div className="bg-[#F1F8FF] flex-shrink-0 px-[6px]  text-[#1A64B9] rounded-sm text-[9px] font-semibold text-nowrap">
              {interventionDate(startDate) ?? "--"}
            </div>
          </div>

          <div className="text-dark text-[10px] font-medium text-nowrap leading-3 truncate w-[99%]">
            {title ?? "--"}
          </div>
        </div>
      </div>
      <div className="flex justify-start 2xl:ml-8 mt-2 gap-2">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`http://maps.google.com/?q=${address} ${ville} ${postCode}`}
          className="bg-[#1A64B9] py-1 px-[6px] rounded-xl text-white font-medium text-[10px] leading-3 flex justify-center items-center gap-1"
        >
          <ZipCodeIcon className="w-[10px] h-[10px] fill-white" />
          <span>{`${postCode ?? "--"} `}</span>
        </a>
        <a
          href={contact?.phone ? `tel:${contact.phone.replace(/\s/g, "")}` : undefined}
          className=" text-[#FF6600] flex justify-center items-center gap-1 py-1 px-[6px] border-[#FF6600] bg-white border-2 font-medium text-[10px] leading-3 rounded-xl "
        >
          <i className="fi fi-rr-phone-call flex items-center"></i>
          {contact?.phone ?? "--"}
        </a>
      </div>
    </div>
  );
};
export default InterventionItem;
